import React, { useEffect } from 'react'
import MediaQuery from 'react-responsive'

import { AcornsIcon, Icon } from '@acorns/icons'
import { Button } from '@acorns/web-components'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import theme from 'theme'

import { STRING_PREFIX } from './CryptoInterstitial'
import { MobileButton } from './MobileButton'
import {
  CenteredContainer,
  MobileButtonContainer,
  SuccessBody,
  SuccessButtonContainer,
  SuccessMarkdownStyler,
  SuccessSecondaryButton,
  SuccessTextContainer,
} from './styled-components'

export const SUCCESS_BUTTON_TYPE_PRIMARY = 'primary'
export const SUCCESS_BUTTON_TYPE_SECONDARY = 'secondary'

export interface SuccessAction {
  text: string
  cta: () => void
  type: string
}

interface CryptoSuccessProps {
  titleKey?: string
  body: string
  screenViewed?: object
  variables?: string[]
  actions: SuccessAction[]
}

export const Success: React.FC<CryptoSuccessProps> = (props) => {
  const { StyledRemoteString } = useRemoteStrings()
  const analytics = useAnalyticsClient()

  useEffect(() => {
    if (props.screenViewed) {
      analytics.track('Screen Viewed', props.screenViewed)
    }
  }, [analytics, props.screenViewed])

  const getDesktopButtonType = (action: SuccessAction, index: number) =>
    action.type === SUCCESS_BUTTON_TYPE_PRIMARY ? (
      <Button
        onPress={action.cta}
        className="add-crypto-success-button"
        key={index}
      >
        {action.text}
      </Button>
    ) : (
      <SuccessSecondaryButton key={index} onClick={action.cta}>
        {action.text}
      </SuccessSecondaryButton>
    )

  const getMobileButtonType = (action: SuccessAction, index: number) =>
    action.type === SUCCESS_BUTTON_TYPE_PRIMARY ? (
      <MobileButton text={action.text} onPress={action.cta} key={index} />
    ) : (
      <MobileButton
        text={action.text}
        onPress={action.cta}
        key={index}
        styleType="flat"
        secondary
      />
    )

  return (
    <CenteredContainer>
      <AcornsIcon icon={Icon.CheckmarkGreenNarrow} height={80} width={80} />
      <SuccessTextContainer>
        <StyledRemoteString
          stringKey={props.titleKey ?? `${STRING_PREFIX}success.title.markdown`}
          modifiers={[{ bold: 600, color: theme.colors.green }]}
          wrappers={[{ component: SuccessMarkdownStyler }]}
          variables={props.variables}
        />
        <SuccessBody>{props.body}</SuccessBody>
      </SuccessTextContainer>
      <MediaQuery minWidth={theme.breakpoints.sm + 1}>
        <SuccessButtonContainer>
          {props.actions.map((action, index) =>
            getDesktopButtonType(action, index),
          )}
        </SuccessButtonContainer>
      </MediaQuery>
      <MediaQuery maxWidth={theme.breakpoints.sm}>
        <MobileButtonContainer>
          {props.actions.map((action, index) =>
            getMobileButtonType(action, index),
          )}
        </MobileButtonContainer>
      </MediaQuery>
    </CenteredContainer>
  )
}
